import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  BoxProps,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { StyledInputField } from "@root/commonStyles/commonStyle";
import React from "react";

export const PasswordInput: React.FC<React.InputHTMLAttributes<BoxProps>> = (
  props
) => {
  const [inputType, setInputType] = React.useState<"text" | "password">(
    "password"
  );
  return (
    <InputGroup>
      <StyledInputField
        borderColor={props.value ? "purple.500" : "gray.200"}
        variant="filled"
        size="full"
        value={props.value}
        as={Input}
        type={inputType}
        {...props}
      />
      <InputRightElement
        onClick={() => setInputType(inputType === "text" ? "password" : "text")}
      >
        {inputType === "text" ? (
          <ViewIcon boxSize={4} color="gray.300" cursor={"pointer"} />
        ) : (
          <ViewOffIcon boxSize={4} color="gray.300" cursor={"pointer"} />
        )}
      </InputRightElement>
    </InputGroup>
  );
};
